import { css } from "styled-components";

/** Shared content card — uses full width of scroll-body (gutter comes from scroll-body padding only) */
export const registrationContentCardStyles = css`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  max-width: 100%;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 32px rgba(30, 42, 53, 0.1);
  border: 1px solid rgba(30, 42, 53, 0.07);
  overflow: hidden;
  box-sizing: border-box;
`;

/** Fluid .scroll-body spacing for viewports 375px–1440px */
export const registrationScrollBodyStyles = css`
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  box-sizing: border-box;
  max-height: 100%;
  width: 100%;
  padding-top: clamp(12px, 1.5vw + 8px, 24px);
  padding-bottom: clamp(12px, 1.5vw + 8px, 24px);
  padding-inline: clamp(16px, 2vw + 8px, 32px);

  .content-card {
    ${registrationContentCardStyles}
    flex: 1 1 auto;
    min-height: 0;
    width: 100%;
    max-width: min(580px, 100%);
    height: 100%;
    max-height: 100%;
    overflow: hidden;
    padding-bottom: calc(16px + env(safe-area-inset-bottom, 0px));
  }

  &.scroll-body-centered {
    justify-content: flex-start;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    .content-card {
      flex: 0 0 auto;
      height: auto;
      max-height: none;
      overflow: visible;
      margin-block: auto;
    }
  }

  @media (orientation: landscape) and (max-width: 1023px),
    (max-height: 520px) {
    padding-top: clamp(8px, 1vh, 12px);
    padding-bottom: clamp(8px, 1vh, 12px);
    padding-inline: clamp(12px, 2vw, 24px);

    .content-card {
      max-height: 100%;
      max-width: min(540px, 100%);
    }
  }

  &.scroll-body-centered .content-card {
    flex: 0 0 auto;
    height: auto;
    max-height: none;
    overflow: visible;
    margin-block: auto;
  }
`;
